// Remarcacao (Bug 7976): totalBpe/totalConvenience/... descrevem o BP-e NOVO inteiro - numa
// remarcacao isso e o preco da passagem, nao o desembolso. O abatimento do bilhete anterior vem do
// backend em order.rebookingCredit (nulo/0 em pedido sem remarcacao) - o Hub NAO consegue derivar
// isso de order.value/AmountPaid (o legado cobra a diferenca por fora; o Hub nunca registra o
// desembolso real ali), entao o credito e resolvido a partir do bilhete original e exposto pronto.
export function computeOrderTotal(order) {
	const composedTotal =
		(order.totalBpe || 0) +
		(order.totalConvenience || 0) +
		(order.totalJuros || 0) +
		(order.totalToll || 0) +
		(order.totalFee || 0) +
		(order.totalInsurance || 0) +
		(order.totalOther || 0) -
		(order.totalDiscount || 0)

	const rebookingCredit = order.rebookingCredit || 0
	const hasRebookingCredit = rebookingCredit > 0

	return {
		total: hasRebookingCredit ? composedTotal - rebookingCredit : composedTotal,
		rebookingCredit,
		hasRebookingCredit,
	}
}
